<div class="role-icons">
    <div *ngFor="let appliRoleIcon of appliRoleIcons">
        <div [ngSwitch]="appliRoleIcon.role"
             title="{{appliRoleIcon.appli + ' / ' + appliRoleIcon.role}}">
            <aa-icon-circle *ngSwitchCase="'NONE'"
                            class="grey duotone"
                            [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
            <aa-icon-circle *ngSwitchCase="'READER'"
                            class="info duotone"
                            [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
            <aa-icon-circle *ngSwitchCase="'USER'"
                            class="blue duotone"
                            [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
            <aa-icon-circle *ngSwitchCase="'MANAGER'"
                            class="success duotone"
                            [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
            <aa-icon-circle *ngSwitchCase="'ADMIN'"
                            class="warning2 duotone"
                            [faIcon]="appliRoleIcon.icon">
            </aa-icon-circle>
        </div>
    </div>
</div>
